import { useBreakpoint } from 'components/util/BreakpointProvider';
import { classNames } from 'libs/react';
import { createContext } from 'libs/react';
import { named } from 'libs/react';
import { useState } from 'libs/react';
import { TableStack } from './private/TableStack';
import { TableBody } from 'components/table/private/TableBody';
import { TableColgroup } from 'components/table/private/TableColgroup';
import { TableFoot } from 'components/table/private/TableFoot';
import { TableHead } from 'components/table/private/TableHead';
import { TableScroll } from 'components/table/private/TableScroll';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { Waiter } from 'components/Waiter';
import { React } from 'libs/react';
import { TableCard } from './private/TableCard';
import './Table.scss';
/**
 * @component Table
 * @since 1.0.0
 */
export function Table(props) {
    const { name, style, title, infos, ready, header, heading, footer, footing, values, sortable, schema, defaultSortOrder, hideTableHeading, primaryColumn, actionsColumn, isCardDisplay, layout } = Object.assign({ style: 'normal', ready: true, header: true, footer: false, layout: 'auto' }, props);
    const { isAboveOrEqual } = useBreakpoint();
    const sort = sortable && sortable[0];
    const [sortField, setSortField] = useState(sort ? sort : '');
    const [sortOrder, setSortOrder] = useState(sort ? (defaultSortOrder ? defaultSortOrder : 'asc') : '');
    const onSort = (field, order) => {
        var _a;
        setSortField(field);
        setSortOrder(order);
        const f = ((_a = schema[field]) === null || _a === void 0 ? void 0 : _a.column) || field;
        if (props.onSort) {
            props.onSort(f, order);
        }
    };
    const table = isAboveOrEqual('lg');
    const className = classNames('table', 'table--' + style, { 'table--has-header': header }, { 'table--has-footer': footer }, { 'table--is-ready': ready }, { 'table--is-empty': ready && values.length == 0 }, { 'table--layout-fixed': layout == 'fixed' }, named('table', name), props.className);
    const context = {
        onSort,
        setSortField,
        setSortOrder,
        sortField,
        sortOrder,
        sortable
    };
    return (React.createElement(TableContext.Provider, { value: context },
        React.createElement("div", { className: className },
            !hideTableHeading && (React.createElement(Case, { is: heading || title || infos },
                React.createElement("div", { className: "table-heading" },
                    React.createElement(Case, { is: heading },
                        React.createElement("div", { className: "table-heading-foot" }, heading))))),
            React.createElement("div", { className: "table-content" },
                React.createElement(Waiter, { until: ready, renderWhileLoading: true },
                    React.createElement(When, null,
                        React.createElement(Case, { is: table }, !isCardDisplay ? (React.createElement(TableScroll, null,
                            React.createElement("table", null,
                                React.createElement(TableColgroup, { schema: schema }),
                                header && React.createElement(TableHead, Object.assign({}, props)),
                                values && React.createElement(TableBody, Object.assign({}, props)),
                                footer && React.createElement(TableFoot, Object.assign({}, props))))) : (React.createElement("div", { className: "table-content-cards-container" }, values.map((value) => (React.createElement(React.Fragment, null,
                            React.createElement(TableCard, { value: value, schema: schema }))))))),
                        React.createElement(Else, null,
                            React.createElement(TableStack, { schema: schema, values: values, primaryColumn: primaryColumn, actionsColumn: actionsColumn }))))),
            footing)));
}
/**
 * @component TableContext
 * @since 1.0.0
 */
export const TableContext = createContext({
    onSort() { },
    setSortField() { },
    setSortOrder() { },
    sortField: '',
    sortOrder: ''
});
